import React, { useState } from 'react';
import { Badge } from 'reactstrap';
import { useThemeContext } from '../contexts/ThemeContext';

const PublicIdDisplay = ({ publicId, className = "", size = "sm" }) => {
  const [copied, setCopied] = useState(false);
  const { theme } = useThemeContext();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(publicId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy public ID:', err);
    }
  };

  const getThemeColors = () => {
    if (copied) {
      return {
        backgroundColor: '#28a745',
        color: '#fff',
        borderColor: '#28a745'
      };
    }
    
    if (theme === 'dark') {
      return {
        backgroundColor: 'var(--bs-gray-800)',
        color: 'var(--bs-gray-200)',
        borderColor: 'var(--bs-gray-600)'
      };
    }
    
    return {
      backgroundColor: 'var(--bs-gray-100)',
      color: 'var(--bs-gray-700)',
      borderColor: 'var(--bs-gray-300)'
    };
  };

  const colors = getThemeColors();

  return (
    <span
      className={`badge public-id-badge ${className}`}
      style={{
        fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
        fontSize: '12px',
        cursor: 'pointer',
        userSelect: 'none',
        border: `1px solid ${colors.borderColor}`,
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        padding: '0.25em 0.5em',
        borderRadius: '0.25rem',
        display: 'inline-block',
        '--hover-color': colors.backgroundColor
      }}
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Click to copy'}
    >
      {copied ? '✓ Copied' : publicId}
    </span>
  );
};

export default PublicIdDisplay;